import React from "react"

const Loading = () => {
  return (
    <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
    ....loading...
  </div>
  )
}

export default Loading